import { MoreHorizOutlined } from '@mui/icons-material';
import { Button, ButtonBaseProps } from '@mui/material';
import { Restricted, RestrictionCheck, useRestricted } from '@procureai/permissions-ui';
import { PropsWithChildren } from 'react';

export interface PageHeaderActionMenuButtonProps extends Omit<ButtonBaseProps, 'variant' | 'color' | 'size'> {
  isIconButton?: boolean;
  needs?: RestrictionCheck;
  intercomTarget?: string;
}

const OutlinedButtonMenu = ({
  intercomTarget,
  children,
  ...buttonProps
}: PropsWithChildren<PageHeaderActionMenuButtonProps>) => {
  return (
    <Button
      {...buttonProps}
      variant="outlined"
      data-intercom-target={intercomTarget}
      sx={(theme) => ({
        // spacing(6) = 40px
        minWidth: theme.spacing(6),
        maxWidth: theme.spacing(6),
        minHeight: theme.spacing(6),
        maxHeight: theme.spacing(6),
      })}
    >
      <MoreHorizOutlined />
    </Button>
  );
};

export const PageHeaderActionMenuButton = ({
  isIconButton = false,
  children,
  needs,
  intercomTarget,
  ...buttonProps
}: PropsWithChildren<PageHeaderActionMenuButtonProps>) => {
  const isAllowed = useRestricted(needs);
  const disabled = !isAllowed || buttonProps.disabled;

  return (
    <>
      <Restricted needs={needs}>
        <OutlinedButtonMenu {...buttonProps} disabled={disabled} intercomTarget={intercomTarget}></OutlinedButtonMenu>
        {children}
      </Restricted>
    </>
  );
};
